/* eslint-disable id-length */
/* eslint-disable max-lines-per-function */
import React, { useContext } from 'react';
import { Utility } from './utils';
import { Input } from '../../../component';
import { DateSection } from './dateSection';
import { ButtonSection } from './buttonSection';
import { YearSection } from './yearSection';
import { MonthSection } from './monthSection';
import Checkbox from '../checkBox';
import {
  returnWeekDays,
  returnMonths,
  returnMonthNameswithKeys,
} from '../../../utils/consts/months';
import { LocaleSettingContext } from '../../../utils/consts/localeSetting';
import './datePicker.scss';
import { CloseIcon } from '~svg/index';
let isDarkMode = false;
class DatePicker extends React.Component {
  static contextType = LocaleSettingContext;
  input;
  fetchHoldiayMonth;
  state = {
    monthIndex: 0,
    yearIndex: 0,
    yearList: 0,
    selectedDate: null,
    showName: '',
    isOpen: false,
    altDateType: 'hijri',
    display: 'date',
    holidays: [],
  };
  onButtonClcik = this.updateMonthIndex;

  componentDidMount() {
    if (this.props.value) this.setInputValue();
  }
  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) this.try();
    else this.hardTry();
  }

  try() {
    if (this.props.value) this.setInputValue();
    else this.clearData();
  }
  hardTry() {
    const { selectedDate } = this.state;
    if (selectedDate && this.props.value) {
      const newDate = new Date(this.props.value);
      newDate.setHours(0, 0, 0, 0);
      if (selectedDate !== newDate.toLocaleString()) this.setInputValue();
    }
  }

  setInputValue() {
    const dateObj = new Date(this.props.value);
    if (isNaN(dateObj)) this.clearData();
    else {
      dateObj.setHours(0, 0, 0, 0);
      const day = Utility.createDayObject(dateObj, this.context.timeZone);
      this.updateSelectedDate(day);
    }
  }

  updateMonthIndex(type) {
    let { monthIndex } = this.state;
    if (type === 'next') monthIndex++;
    else if (type === 'previous') monthIndex--;

    this.fetchHolidays(monthIndex);
    this.setState({ monthIndex });
  }

  updateMonthAsYear(type) {
    let { monthIndex } = this.state;
    if (type === 'next') monthIndex += 12;
    else if (type === 'previous') monthIndex -= 12;
    this.setState({ monthIndex });
  }

  updateYearIndex(type) {
    let { yearIndex } = this.state;
    if (type === 'next') yearIndex += 12;
    else if (type === 'previous') yearIndex -= 12;
    this.setState({ yearIndex });
  }

  fetchHolidays(monthIndex) {
    const localState = JSON.parse(localStorage.getItem('state'));
    const { month } = DatePicker.Utility.currentDate(
      monthIndex,
      this.context.direction,
      this.context.timeZone,
      localState.language?.name,
    );
    this.fetchHoldiayMonth = month;
    DatePicker.Utility.fetchMonthHoliday(month, localState.language?.name)
      .then(this.fillHoldays.bind(this))
      .catch(this.onHolidaysCatch.bind(this));
  }

  fillHoldays({ month, holidays }) {
    if (this.fetchHoldiayMonth === month)
      this.setState({ holidays: holidays.payload.data });
  }
  onHolidaysCatch(error, month) {
    if (this.fetchHoldiayMonth === month) this.setState({ holidays: [] });
  }

  changeDisplay(display) {
    switch (display) {
      case 'year':
        this.onButtonClcik = this.updateYearIndex;
        break;
      case 'date':
        this.onButtonClcik = this.updateMonthIndex;
        break;
      case 'month':
        this.onButtonClcik = this.updateMonthAsYear;
        break;
      default:
        break;
    }
    this.setState({ display });
  }

  clearData() {
    if (typeof this.props.onChange === 'function')
      this.props.onChange(null, null);
    this.setState({ selectedDate: null, showName: '' });
  }

  selectDate(day, selectable) {
    if (selectable) {
      if (typeof this.props.onChange === 'function')
        this.props.onChange(day.date.toLocaleString(), day);
      this.updateSelectedDate(day);
      this.closeDatePicker();
    }
  }

  updateSelectedDate(day) {
    this.setState({
      selectedDate: day.date.toLocaleString(),
      showName: this.returnShowDate(day),
    });
  }

  returnShowDate = (dayObj) => {
    const { direction } = this.context;
    const localState = JSON.parse(localStorage.getItem('state'));
    if (direction === 'ltr') return dayObj.date.toString().substring(0, 15);
    else {
      if (localState?.language?.name === 'fa') {
        const weekDays = returnWeekDays(direction);
        const monthList = returnMonths(direction);
        return `${weekDays[(dayObj.date.getDay() + 1) % 7]} ${
          dayObj.shamsi[2]
        } ${monthList[parseInt(dayObj.shamsi[1] - 1)].Name} ${
          dayObj.shamsi[0]
        }`;
      }
      if (localState?.language?.name === 'ar') {
        const weekDays = returnWeekDays('ar');
        const monthName = returnMonthNameswithKeys(
          'miladi',
          localState?.language?.name,
          parseInt(dayObj?.miladi?.[1]),
        );
        return `${weekDays[dayObj.date.getDay() % 7]} ${
          dayObj.miladi[2]
        } ${monthName} ${dayObj.miladi[0]}`;
      }
    }
  };

  changeAltType({ target }) {
    this.setState({ altDateType: target.name });
  }

  changeYear(year, currentYear) {
    const monthDiff = (year - currentYear) * 12,
      monthIndex = this.state.monthIndex + monthDiff;
    this.setState({ monthIndex });
    this.changeDisplay('date');
  }

  changeMonth(month, currentMonth) {
    const monthDiff = month.index - currentMonth,
      monthIndex = this.state.monthIndex + monthDiff;
    this.setState({ monthIndex }, () => this.fetchHolidays(monthIndex));
    this.changeDisplay('date');
  }

  closeDatePicker() {
    this.input.style.zIndex = '1';
    this.setState({ isOpen: false });
  }
  openDatePicker() {
    this.input.style.zIndex = '12';
    this.fetchHolidays(this.state.monthIndex);
    this.setState({ isOpen: true });
  }

  render() {
    const { themeMode } = this.props;
    const PopupMainBody = DatePicker.PopupMainBodyCreator.bind(this);
    isDarkMode = themeMode === 'dark';
    return (
      <div className={`col p-0 datepicker-responsive`}>
        <DatePicker.Utility.Overlay
          show={this.state.isOpen}
          callback={this.closeDatePicker.bind(this)}
        />
        <div className={`col p-0 position-relative `}>
          <div
            className="position-relative"
            ref={(input) => (this.input = input)}
          >
            <Input
              tabIndex={this.props.tabIndex}
              name={this.props.name}
              className={this.props.inputClassName}
              inputClassName={`${this.props.inputClassName ?? 'font-normal'}  `}
              style={{
                border: '1px solid #ccc',
                ...this.props.inputStyle,
              }}
              error={this.props.error}
              onClick={this.openDatePicker.bind(this)}
              onFocus={this.openDatePicker.bind(this)}
              onKeyDown={(e) => {
                e.key === 'Tab' ? this.closeDatePicker() : null;
              }}
              themeMode={isDarkMode ? 'dark' : 'light'}
              label={this.props.placeholder || 'date'}
              value={this.state.showName}
              iconUrl={null}
              readOnly
              outSideLabelClass={`text-start ${this.props.outSideLabelClassname}`}
              outSideLabelPosition="top"
              outSideLabel={true}
              heightSize="date-picker-height px-lg-0 px-3"
            />
            <DatePicker.ClearButton
              show={this.state.selectedDate}
              onClick={this.clearData.bind(this)}
            />
          </div>
          <DatePicker.PopupSection show={this.state.isOpen}>
            <DatePicker.ButtonSection
              monthIndex={this.state.monthIndex}
              onClick={this.onButtonClcik.bind(this)}
              changeDisplay={this.changeDisplay.bind(this)}
              display={this.state.display}
              isDarkMode={isDarkMode}
            />
            <PopupMainBody />
          </DatePicker.PopupSection>
        </div>
      </div>
    );
  }
}

DatePicker.createCustomProto(
  {
    PopupSection: function ({ show, children }) {
      if (show)
        return (
          <div
            className={`p-0 border rounded bg-white boxShadowForDatePicker calendar-popup-modal datePicker-profile ${
              isDarkMode ? 'bg-primary-dark' : ''
            }`}
          >
            {children}
          </div>
        );
      else return null;
    },
    PopupMainBodyCreator: function PopupMainBodyCreator() {
      switch (this.state.display) {
        case 'date':
          const holidays = this.state.holidays.filter(
            (item) => item.isVacation === 1,
          );
          return (
            <>
              <DatePicker.DateSection
                monthIndex={this.state.monthIndex}
                holidays={holidays}
                select={this.selectDate.bind(this)}
                selectedDate={this.state.selectedDate}
                altDateType={this.state.altDateType}
                disableBeforeDate={this.props.disableBeforeDate}
                isDarkMode={isDarkMode}
              />
              <DatePicker.CheckBoxes
                altDateType={this.state.altDateType}
                onChange={this.changeAltType.bind(this)}
                isDarkMode={isDarkMode}
              />
            </>
          );
        case 'year':
          return (
            <DatePicker.YearSection
              yearIndex={this.state.yearIndex}
              monthIndex={this.state.monthIndex}
              onChange={this.changeYear.bind(this)}
              isDarkMode={isDarkMode}
            />
          );
        case 'month':
          return (
            <DatePicker.MonthSection
              monthIndex={this.state.monthIndex}
              onChange={this.changeMonth.bind(this)}
              isDarkMode={isDarkMode}
            />
          );
        default:
          return null;
      }
    },
    ClearButton: function ClearButton({ show, onClick }) {
      const { direction } = useContext(LocaleSettingContext);
      if (show)
        return (
          <div
            className=" position-absolute pt-2 px-2"
            style={{
              top: '65%',
              [direction === 'ltr' ? 'right' : 'left']: '0',
              transform: 'translate(0, -50%)',
            }}
            onClick={onClick}
          >
            <CloseIcon size={14} color="red" />
          </div>
        );
      else return null;
    },
    CheckBoxes: function CheckBoxes({ altDateType, onChange, isDarkMode }) {
      const { direction } = useContext(LocaleSettingContext);
      const list = ['hijri'];
      if (direction === 'ltr') list.push('shamsi');
      else list.push('miladi');
      return (
        <div className="col d-flex p-0 m-0 px-2 mb-1">
          {list.map((type) => (
            <Checkbox
              key={type}
              name={`${type}`}
              label={type.capitalize()}
              inputClassName="font-smaller checkbox-calendar text-third"
              checked={altDateType === type}
              onChange={onChange}
              theme={'light'}
            />
          ))}
        </div>
      );
    },
    DateSection,
    YearSection,
    MonthSection,
    ButtonSection,
    Utility,
  },
  true,
  true,
);

export default DatePicker;
